<template>
  <div class="leFooter">
    <div class="top-line"></div>
    <ul>
      <li><a href="https://www.are.na/gee7-bi" target="_blank">Are.na</a></li>
        <li><a href="https://www.linkedin.com/in/gunjan-bhutani-05036b31/" target="_blank">LinkedIn</a></li>
        <li><a href="https://www.instagram.com/gunjanb_co/" target="_blank">Instagram</a></li>
    </ul>
    <div class="footer-text"><p>"For any questions or further details about the projects, please reach out to me."</p>
      <p class="copyright">
        © Gunjan Bhutani 2019
      </p></div>
  </div>
</template>

<script>
export default {
  name: "Lefooter"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.leFooter
  margin-top 10vh
  padding 20px
  .top-line
    margin 0 auto
    text-align center
    width 90px
    height 5px
    background-image url("../assets/bg-border.png")
    background-size 9px 5px
    margin-bottom 2rem
  .footer-text
    font-size .875rem
    text-align center
    margin 0 auto
    max-width 320px
    .copyright
      font-size .625rem
      text-transform uppercase
  ul
    list-style none
    margin 0
    padding 0
    width 100%
    text-align center
    li
      text-align center
      display inline-block
      padding 1rem
      font-size .875rem
      
</style>